import { render } from "./BannerCarousel.vue?vue&type=template&id=03b98f30&ts=true"
import script from "./BannerCarousel.vue?vue&type=script&lang=ts"
export * from "./BannerCarousel.vue?vue&type=script&lang=ts"

import "./BannerCarousel.vue?vue&type=style&index=0&id=03b98f30&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__